var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-gadget"},[_c('div',{staticClass:"help-box"}),_c('button',{staticClass:"gadget-button"},[_c('QuestionIcon',{staticClass:"icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }